var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { InlineInputForm } from '@ui/general';
import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
export const ViewForm = (_a) => {
    var { currentName } = _a, rest = __rest(_a, ["currentName"]);
    return React.createElement(InlineInputForm, Object.assign({ cancelProps: { id: currentName ? 'edit-view-cancel' : 'create-view-cancel' }, className: 'view-form', confirmProps: {
            id: currentName ? 'edit-view-confirm' : 'create-view-confirm'
        }, currentValue: currentName, inputProps: {
            id: currentName ? 'edit-view-input' : 'create-view-input',
            placeholder: PLACEHOLDERS_COPY.NAME_YOUR_VIEW
        }, maxLength: 55 }, rest));
};
